/**
 * Provider API
 *
 * Low-level API calls for Provider entity.
 * This is the infrastructure layer - handles HTTP requests.
 *
 * Note: This file coexists with the legacy src/services/admin/provider-service.js
 * to allow gradual migration. New code should use this file.
 */
import api from "./axios";
// =============================================================================
// PROVIDER API
// =============================================================================
export const providerApi = {
    /** Fetch all providers */
    getAll() {
        return api.get("/provider");
    },
};
// =============================================================================
// DEFAULT EXPORT
// =============================================================================
export default providerApi;
